module.exports = __webpack_public_path__ + "img/none.2ae49c5e.png";